import api from './baseApi';

export interface Author {
  user_id: string;
  name: string;
  avatar_url: string;
}

export enum MediaDetailsStatus {
  PROCESSING = 'PROCESSING',
  READY = 'READY',
  DELETED = 'DELETED',
}

export enum CommentMediaType {
  IMAGE = 'image',
  VIDEO = 'video',
}

export interface Comment {
  _id: string;
  createdAt: string;

  tribe_id: string;
  post_id: string;
  author: Author;
  text: string;
  is_deleted: boolean;

  media_type: CommentMediaType;
  media_url?: string;
  media: {
    status: MediaDetailsStatus;
    file_id?: string;
    height?: number;
    width?: number;
    thumbnail_url?: string;
  };

  like_count: number;
  liked_by: string[];
  hidden_by: string[];

  parent_id?: string;
}

export const commentsApi = {
  postComment: async (
    postId: string,
    data: {
      text?: string;
      file_id?: string;
      media_type?: CommentMediaType;
      parent_id?: string;
    }
  ): Promise<Comment> => {
    const axiosResponse = await api.post(`posts/${postId}/comments`, data);
    return axiosResponse.data.result;
  },

  toggleLikeComment: async (
    postId: string,
    commentId: string
  ): Promise<Comment> => {
    const axiosResponse = await api.put(
      `posts/${postId}/comments/${commentId}/like`,
      {}
    );
    return axiosResponse.data.result;
  },

  updateCommentText: async (
    postId: string,
    commentId: string,
    data: { text: string }
  ): Promise<Comment> => {
    const axiosResponse = await api.patch(
      `posts/${postId}/comments/${commentId}`,
      data
    );
    return axiosResponse.data.result;
  },

  deleteComment: async (postId: string, commentId: string): Promise<void> => {
    await api.delete(`posts/${postId}/comments/${commentId}`);
  },
};
